var getInitials = function getInitials(user) {
  var _user$firstname, _user$lastname;
  if (!user) {
    return '';
  }
  return "".concat(((_user$firstname = user.firstname) === null || _user$firstname === void 0 ? void 0 : _user$firstname.charAt(0)) || '').concat(((_user$lastname = user.lastname) === null || _user$lastname === void 0 ? void 0 : _user$lastname.charAt(0)) || '');
};

export { getInitials };
